import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import SrDarkModal from 'client/components/SrDarkModal';
import SrFrontConversationView from 'client/components/SrFrontConversationView';
import SrFrontConversationForm from 'client/components/SrFrontConversationForm';

import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import branch from 'client/core/branch';

@branch({
  currentUser: ['currentUser'],
})
class SrFrontConversationModal extends Component {
  static propTypes = {
    frontConversationId: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      inProgress: true,
    };

    this.frontConversationViewRef = createRef();
  }

  _onMessageSent = (newFrontMessage) => {
    this.frontConversationViewRef.current.addMessage(newFrontMessage);
  };

  render() {
    const { onClose, user, frontConversationId, dispatch, currentUser } = this.props;
    const { inProgress } = this.state;

    return (
      <SrDarkModal onClose={onClose}>
        <div
          onClick={preventDefaultPropagation}
          className="adminDefaultModal SrFrontConversationModal"
        >
          <div className="frontConversationContainer">
            <SrFrontConversationView
              ref={this.frontConversationViewRef}
              user={user}
              frontConversationId={frontConversationId}
              dispatch={dispatch}
              onLoaded={() => this.setState({ inProgress: false })}
            />
            {!inProgress && (
              <SrFrontConversationForm
                frontConversationId={frontConversationId}
                user={user}
                dispatch={dispatch}
                onMessageSent={this._onMessageSent}
                currentUser={currentUser}
              />
            )}
          </div>
        </div>
      </SrDarkModal>
    );
  }
}

SrFrontConversationModal.displayName = 'SrFrontConversationModal';

export default SrFrontConversationModal;
